"use client";

import React from "react";
import styles from "../styles/sidebar-section.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

type SidebarSectionProps = {
  image: string;
  title: string;
  href: string;
  onClick?: () => void;
};

const SidebarSection = ({
  image,
  title,
  href,
  onClick,
}: SidebarSectionProps) => {
  const { hideModal } = useGlobalModalContext();

  const handleClick = () => {
    hideModal();

    if (onClick) onClick();
  };

  return (
    <Link className={styles.dropdown_header} href={href} onClick={handleClick}>
      <Image className={styles.section_image} src={image} alt={title} />
      <div className={styles.section_title}>{title}</div>
    </Link>
  );
};

export default SidebarSection;
